import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useData } from "../util/dataProvider";

export default function VerifyEmail() {
    const navigate = useNavigate();
    const [send, setSend] = useState(false);
    const { user } = useData();
    function sendEmail() {
        user.sendEmailVerification().then((response) => {
            setSend(true);
        });
    }
    return (
        <div id='ProfilSelect'>
            <div className='big-title' style={{ marginBottom: "32px" }}>
                Mein bergisch.metall
            </div>
            <div className='container'>
                <div>
                    Bitte bestätige deine E-Mail-Adresse, um fortzufahren.
                    <br />
                    {!send ? (
                        <button
                            type='button'
                            className='button-red'
                            onClick={() => sendEmail()}>
                            E-Mail erneut senden
                        </button>
                    ) : (
                        <div>E-Mail wurde verschickt.</div>
                    )}
                </div>
            </div>
        </div>
    );
}
